import { render, staticRenderFns } from "./NewOrganizationDashboard.vue?vue&type=template&id=9d0d3ab4&"
import script from "./NewOrganizationDashboard.vue?vue&type=script&lang=js&"
export * from "./NewOrganizationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NewOrganizationDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports